import * as React from 'react';
import { Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Signin from './signin';
import Register from './register';
import ResetPassword from './resetPassword';
import './index.css';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

class AccountModal extends React.Component<
  {
    visible: boolean;
    activeTab: string;
    onClose: () => void;
  },
  {
    activeTab: string;
    isResetPassword: boolean;
  }
  > {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab,
      isResetPassword: false
    };
  }

  public componentWillReceiveProps(newProps) {
    const newState: any = {};
    newState.activeTab = newProps.activeTab;
    this.setState(newState);
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.visible}
        size='md'
        toggle={() => this.props.onClose()}
      >
        <ModalHeader toggle={() => this.props.onClose()}></ModalHeader>
        <ModalBody>
          {
            this.state.isResetPassword ? <ResetPassword
              onSignIn={() => this.setState({ isResetPassword: false })}
            /> :
              <div>
                <Nav tabs id='accountTab'>
                  <NavItem>
                    <NavLink
                      onClick={() => this.setState({ activeTab: 'tab-signin' })}
                      className={classnames({
                        active: this.state.activeTab === 'tab-signin'
                      })}
                    >
                      <FormattedMessage id='Signin' />
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() => this.setState({ activeTab: 'tab-register' })}
                      className={classnames({
                        active: this.state.activeTab === 'tab-register'
                      })}
                    >
                      <FormattedMessage id='Register' />
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId='tab-signin'>
                    <Signin
                      loginSuccess={() => {
                        this.props.onClose();
                      }}
                      onResetPassword={() => this.setState({ isResetPassword: true })}
                    />
                  </TabPane>
                  <TabPane tabId='tab-register'>
                    <div>
                      <Register />
                    </div>
                  </TabPane>
                </TabContent>
              </div>
          }
        </ModalBody>
      </Modal>
    );
  }
}

export default AccountModal;



// WEBPACK FOOTER //
// ./src/components/accountModal/accountModal.tsx